import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import { required } from '@swf/core/utils/validators';

import RMFDropDown from '../../../RMFDropDown/RMFDropDown';

import {
  TXTCLI_DriverXs_License,
  TXTCLI_National_Identity_Card,
  TXTCLI_Passport,
  TXTWCL_Document_type,
  TXTWCL_Please_choose_document_type
} from './DocumentTypeField.messages.json';
import { wrapper } from './DocumentTypeField.scss';

export const docTypeField = 'docType';

export enum RmfDocumentType {
  IdentityCard = 1,
  DriversLisence = 2,
  Passport = 3
}

const DocumentTypeField: React.FC = () => {
  const options = [
    {
      text: <Translation {...TXTCLI_National_Identity_Card} />,
      value: RmfDocumentType.IdentityCard
    },
    {
      text: <Translation {...TXTCLI_DriverXs_License} />,
      value: RmfDocumentType.DriversLisence
    },
    { text: <Translation {...TXTCLI_Passport} />, value: RmfDocumentType.Passport }
  ];

  return (
    <RMFDropDown
      id={docTypeField}
      label={TXTWCL_Document_type}
      options={options}
      validators={[required(TXTWCL_Please_choose_document_type)]}
      className={wrapper}
    />
  );
};

export default DocumentTypeField;
